import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { WithAPI } from 'console/shared/api/api-context';
import { any2unix, binarySearchByField } from 'utils';
export function GetStillPhotoImpl({ api, device_id, time, photos_from_server, }) {
    if (photos_from_server.length === 0 || device_id == null)
        return _jsx(_Fragment, {});
    const unixtime = any2unix(time);
    const [delta_unixtime_min, delta_unixtime_max] = [unixtime - 600, unixtime + 600];
    const { l, r } = binarySearchByField(photos_from_server, 'unixtime', unixtime);
    if (l === -1 || r === 0)
        return _jsx(_Fragment, {});
    const [left_photo, right_photo] = [
        photos_from_server[l],
        photos_from_server[r === photos_from_server.length ? r - 1 : r],
    ];
    //Теперь проверяем, кто вышел за пределы 10 минут
    if ((left_photo.unixtime > delta_unixtime_min &&
        left_photo.unixtime < delta_unixtime_max) ||
        (right_photo.unixtime > delta_unixtime_min &&
            right_photo.unixtime < delta_unixtime_max)) {
        //Теперь кто ближе к исходной фотке
        const delta_left = Math.abs(left_photo.unixtime - unixtime);
        const delta_right = Math.abs(right_photo.unixtime - unixtime);
        let selected_photo = left_photo;
        if (delta_left > delta_right)
            selected_photo = right_photo;
        return (_jsx("img", { src: api.get_url('get_single_photo', {
                unixtime: selected_photo.unixtime.toString(),
                device_id: device_id.toString(),
            }, true), alt: selected_photo.filename, height: 120, width: 160, style: { margin: 3 } }));
    }
    return _jsx(_Fragment, {});
}
export const GetStillPhoto = WithAPI(GetStillPhotoImpl);
